import {
    MOVE_TO_OTHER_ACCOUNT_REQUEST,
    MOVE_TO_OTHER_ACCOUNT_RESULT,
    MOVE_TO_OTHER_ACCOUNT_OPEN_MODAL,
    MOVE_TO_OTHER_ACCOUNT_CLOSE_MODAL,
    MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST,
    MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_RESULT,
    MOVE_TO_OTHER_ACCOUNT_SET_DEVICE,
} from 'Redux/actionTypes';

export const moveToOtherAccountRequest = (data) => ({
    type: MOVE_TO_OTHER_ACCOUNT_REQUEST,
    payload: data
})

export const moveToOtherAccountResult = (result) => ({
    type: MOVE_TO_OTHER_ACCOUNT_RESULT,
    payload: result
})

export const moveToOtherAccountOpenModal = (items) => ({
    type: MOVE_TO_OTHER_ACCOUNT_OPEN_MODAL,
    payload: items
})

export const moveToOtherAccountCloseModal = () => ({
    type: MOVE_TO_OTHER_ACCOUNT_CLOSE_MODAL
})

export const moveToOtherAccountGetDeviceRequest = (item, accountId) => ({
    type: MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST,
    payload: { devices: item, accountId: accountId }
})

export const moveToOtherAccountGetDeviceResult = (result) => ({
    type: MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_RESULT,
    payload: result
})

export const moveToOtherAccountSetDevice = (device) => ({
    type: MOVE_TO_OTHER_ACCOUNT_SET_DEVICE,
    payload: device
})